<template>
  <div class="modal fade" ref="documentModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Document</h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submit">
            <div class="mb-3">
              <label class="form-label">Name</label>
              <input type="text" class="form-control" v-model="name" placeholder="Enter name" required />
            </div>

            <button class="btn btn-primary w-100 btn-sm">Submit</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from "bootstrap";

export default {
  name: "DocumentModal",
  data() {
    return {
      modal: null,
      name: "",
    };
  },
  methods: {
    open() {
      this.name = "";
      this.modal.show();
    },
    close() {
      this.modal.hide();
    },
    submit() {
      this.$emit("save", this.name);
      this.close();
    },
  },
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.documentModal);
  },
};
</script>
